
export default class {
    static isSectionValid(section) {
        let valid = true
        section.fields.forEach(field => {
            
            if(field.required && !field.value) {
                valid = false
                return
            }
        })
        return valid
    }

    static isPageValid(page) {
        let valid = true
        page.sections.forEach(section => {
            if(!this.isSectionValid(section)) {
                valid = false
                return
            }
                
        })
        return valid
    }

    static getSectionField(section, name) {
        return section.fields.find(o => o.name == name) || null
    }

    static parseOptions(options) {
        if(!options)
            return []
        if(Array.isArray(options))
            return options

        return (options || String('')).split(',').map(s => s.trim())
    }

}


// WEBPACK FOOTER //
// ./src/screens/ScreenHelpers.js